import { Inject, ViewChild, Component, Input, ChangeDetectorRef, SimpleChanges } from "@angular/core";
import { ConfMessageProvider } from "../../providers/confMessageProvider";
import { ProductDataStore } from "../../../shared/providers/productData";
import { DataRowView } from "../../../../shared/components/shared";
import { GridRow } from "../../../shared/models/responses";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { Conf, DataSelector, ConfUIItem, ConfDataSelectorValue } from "../../../shared/models";
import { VisualObjectHelper } from "../../parameters/shared";
import { AbstractDataSelectorGridComponent, DataSelectorStore, DataSelectorActionCreator, DataSelectorController } from "../../decorations/dataSelector";
import { GlobalDataStore } from "../../../shared/providers/globalData/globalDataStore";
import { PagerService } from "../../../shared/components/pager/pagerService";

@Component({
  selector: 'luminaries-detail',
  templateUrl: './luminariesDetailComponent.html',
  providers: [DataSelectorStore, DataSelectorActionCreator, DataSelectorController]
})
export class LuminariesDetailComponent extends AbstractDataSelectorGridComponent {

  public showPager: boolean = false;
  public actionBoxTitle: string;

  @Input()
  public isPrintView: boolean = false;

  @Input()
  public confUIItem: ConfUIItem;

  constructor(
    @Inject(ConfMessageProvider) public confMessageProvider: ConfMessageProvider,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,
    @Inject(DataSelectorStore) public dataSelectorStore: DataSelectorStore,
    @Inject(ProductDataStore) public productStore: ProductDataStore,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,
    @Inject(GlobalDataStore) public globalDataStore: GlobalDataStore,
    @Inject(PagerService) public pagerService: PagerService,
    public cdr: ChangeDetectorRef
  ) {
    super(confMessageProvider, dataSelectorStore, productStore, confStore, storeSession, visualObjectHelper, globalDataStore, pagerService);
  }

  ngOnInit() {

    this.onDataReady();

  }

  onDataReady(): void {

    this.decoration = this.productStore.getEntity<DataSelector>(this.confUIItem.id);

    this.actionBoxTitle = this.decoration.title ? this.decoration.title : this.strings.DataSelector;

    let conf: Conf = this.storeSession.activeConfiguration;

    if (conf.dataSelectorValues && conf.dataSelectorValues.size > 0) {

      let confSelectorValueId = conf.dataSelectorValues.first();

      let confDataSelectorValue: ConfDataSelectorValue = this.confStore.getConfDataEntity<ConfDataSelectorValue>(this.storeSession.activeConfigurationId, this.storeSession.confSessionId, this.decoration.visualObjectId)      
      if (confDataSelectorValue) {
        this.confValue = confDataSelectorValue;
        this.setGridData(confDataSelectorValue.gridData);
      }
    }

  }


  public handleSetSelectedValueError() {
    // TODO we should use a popup dialog to display the error.
  }
  public handleSetSelectedValueSuccess() {
  }

}